
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import SaleService from '@/services/sale'
import { productColor } from '@/utils/product'

export default {
  page: {
    title: "Carrinhos Abandonados",
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Carrinhos Abandonados ",
      carts: [],

      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,

      showModal: false,
      cartSelected: {
        items: [],
      },

      fields: [
        { key: 'user.customer.name', sortable: false, label: 'Cliente' },
        { key: 'user.name', sortable: false, label: 'Usuário' },
        { key: 'date', sortable: false, label: 'Última Interação', formatter: (value, i, item) => {
          return this.$moment(item.last_update || item.modified_at).format('DD/MM/YYYY HH:mm:ss');
        } },
        { key: 'items.length', sortable: false, label: 'Qtde. Itens' },
        { key: 'total_value', sortable: false, label: 'Valor Carrinho', formatter: (value) => {
          return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        } },
        { key: 'action', sortable: false, label: '' },
      ]
    }
  },
  computed: {
    rows() {
      return this.products.length;
    }
  },
  mounted() {
    this.load(1);
  },
  methods: {
    productColor,
    load(page) {
      let loader = this.$loading.show();

      SaleService.getAbandonedCarts(page).then(res => {
        loader.hide();

        this.carts = res.data.data;

        this.count = res.data.count;
        this.currentCount = res.data.currentCount;
        this.currentPage = res.data.currentPage;
        this.totalPages = res.data.totalPages;
        this.perPage = res.data.perPage;
        this.startIndex = res.data.startIndex;
        this.endIndex = res.data.endIndex;
      }).catch(() => {
        loader.hide();
      })
    },
    onPageChange() {
      this.load(this.currentPage);
    },
    search() {
      this.load(1);
    },
    exportData() {
      let loader = this.$loading.show();

      SaleService.downloadAbandonedCarts().then(res => {
        loader.hide();

        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', `carrinhos-abandonados.csv`);
        document.body.appendChild(fileLink);

        fileLink.click();
      }).catch(() => {
        loader.hide();
      })
    },
    showItems(cart) {
      this.cartSelected = cart;
      this.showModal = true;
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-12 text-right">
                <button class="btn btn-rounded btn-outline-secondary" @click="exportData">
                  Exportar Dados
                </button>
              </div>
            </div>
            
            <div class="table-responsive mb-0">
              <b-table
                show-empty
                emptyText="Nenhum registro para exibir"
                :items="carts"
                :fields="fields"
                responsive="sm"
                head-variant="light"
              >
                <template v-slot:cell(action)="row">
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm btn-rounded"
                    @click="showItems(row.item)"
                  >Ver Produtos</button>
                </template>
              </b-table>
            </div>  
            
            <div class="row justify-content-md-between align-items-md-center mt-4">
              <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>

              <div class="col-xl-5">
                <div class="text-md-right float-xl-right mt-2 pagination-rounded">
                  <b-pagination
                    v-model="currentPage" 
                    :total-rows="count"
                    :per-page="perPage"
                    @input="onPageChange"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="showModal" title="Itens do Carrinho" scrollable size="lg">
      <div class="table-responsive">
        <table class="table table-centered">
          <thead>
            <tr>
              <th scope="col">Produto</th>
              <th scope="col">Cód.</th>
              <th scope="col">Descrição</th>
              <th scope="col" class="text-right">Qtde.</th>
              <th scope="col" class="text-right">Preço</th>
              <th scope="col" class="text-right">Subtotal</th>
            </tr>
          </thead>
          <tbody v-if="cartSelected.items">
            <tr v-for="item of cartSelected.items" :key="item._id">
              <td>
                <div>
                  <img :src="item.product.images[0].url" alt class="avatar-sm" />
                </div>
              </td>
              <td>{{item.product.code || item.product.sku}}</td>
              <td>
                <div>
                  <h5 class="font-size-13 mb-1">{{item.product.description}}</h5>
                  <p class="text-muted font-size-11 mb-0" v-if="productColor(item.product)">Cor: {{productColor(item.product)}}</p>
                  <p class="text-muted font-size-11 mb-0" v-for="(complement, index) in item.complements" :key="index">
                    {{complement.quantity}}x {{complement.description}}
                  </p>
                  <p class="text-muted font-size-11 mb-0" v-if="item.note">Obs.: {{item.note}}</p>
                </div>
              </td>
              <td class="text-right">{{item.quantity}}</td>
              <td class="text-right">{{(item.price || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}}</td>
              <td class="text-right">{{((item.quantity * item.price) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="showModal = false">Fechar</b-button>
      </template>
    </b-modal>
  </Layout>
</template>

<style lang="scss">
  .search-box form {
    display: flex;
    flex-direction: row;
  }

  .search-box .form-control {
    padding-left: 20px;
  }

  .input-search {
    width: 90%;
  }
</style>